export default __webpack_public_path__ + "static/media/tbs.c86b02ba.jpeg";